<div class="container">
  <div class="wrapper">
    <h1 class="pageTitle">{{ pageTitle }}</h1>
    <app-notifications
      [notification]="'calendar_page_notification_banner_child'"
    ></app-notifications>
    <hr />
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <div *ngIf="selectedDepartment && selectedService">
          <app-mat-calendar
            [service]="selectedService"
            [location]="selectedLocation"
            [component]="component"
            class="row"
          >
          </app-mat-calendar>
        </div>
      </div>
    </div>

    <br />
    <!-- 
    <div class="row">
        <div class="col-sm-12 col-md-12">
            <p>{{'CALENDAR.INFO_TEXT' | translate}}</p>
        </div>
    </div> -->

    <div class="row mt-5 mb-5">
      <div class="col-6">
        <button
          class="btn btn-primary"
          (click)="routerGoBack()"
          title="Back"
          aria-label="Back to locations"
        >
          <span
            ><fa-icon [icon]="faChevronLeft"></fa-icon
            ><span>{{ 'COMMON.BACK' | translate }}</span></span
          >
        </button>
      </div>
      <div class="col-6">
        <button
          class="btn btn-primary float-right"
          (click)="continue()"
          title="Next"
          aria-label="Next to booking details"
        >
          <span
            ><span>{{ 'COMMON.NEXT' | translate }}</span
            ><fa-icon [icon]="faChevronRight"></fa-icon
          ></span>
        </button>
      </div>
    </div>
  </div>
</div>
